let licenseExpiredActive = false;

export const setLicenseExpiredActive = (value) => {
  licenseExpiredActive = Boolean(value);
};

export const isLicenseExpiredActive = () => licenseExpiredActive;
